module.exports = __webpack_public_path__ + "static/media/alliedHealth.23fd39f0.png";